// frontend/src/components/profile-components/ProfileHeader.js

import React from 'react';
import { Link } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthContext';
import { LogOut, LogIn, Wallet, Gift, CreditCard } from 'lucide-react';
import WalletBalanceCard from './WalletBalanceCard';

export default function ProfileHeader() {
    const { 
        user, 
        isLoggedIn, 
        handleLogout, 
        openAuthModal 
    } = useAuthContext();

    // آدرس تصاویر زمینه (background)
    const guestBgUrl = 'https://s3.afra.kubit.cloud/mahsacanva1365-far-free/profile/p1.png';
    const loggedInBgUrl = 'https://s3.afra.kubit.cloud/mahsacanva1365-far-free/profile/p2.png';

    console.log("PROFILE HEADER DEBUG: 3. Render Check -> LoggedIn:", isLoggedIn, "User Object:", user);

    // ------------------------------------
    // حالت مهمان (Guest)
    // ------------------------------------
    if (!isLoggedIn) {
        return (
            <>
                <div 
                    className="p-6 pt-12 text-white rounded-b-3xl shadow-xl bg-cover bg-center bg-no-repeat"
                    style={{ 
                        backgroundImage: `url(${guestBgUrl})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center'
                    }}
                >
                    <div className="flex justify-between items-start mb-4">
                         <button 
                            onClick={openAuthModal}
                            className="p-2 -m-2 rounded-full hover:bg-white/20 transition duration-150"
                            title="ورود به حساب کاربری"
                         >
                             <LogIn size={24} className="text-white opacity-80" />
                         </button>
                         <div className="opacity-70"></div> 
                    </div>
                    
                    <h1 className="text-2xl font-extrabold mb-1 text-center">
                        
                    </h1>
                    <p className="text-[11px] opacity-90 mb-4 text-right">
                        برای تجربه‌ی کاربری بهتر لطفا وارد شوید
                    </p>
                </div>

                {/* سه کادر حالت مهمان (غیرفعال) */}
                <div className="p-4 -mt-10 relative z-5 mb-16">
                    <div className="grid grid-cols-3 gap-3">
                        <div className="bg-white p-3 rounded-xl shadow-lg text-center rtl flex flex-col items-center justify-center opacity-80">
                            <Wallet size={24} className="text-gray-500 mb-2" />
                            <span className="text-[8pt] font-regular text-gray-400 leading-tight">موجودی کیف پول</span>
                        </div>
                        <div className="bg-white p-3 rounded-xl shadow-lg text-center rtl flex flex-col items-center justify-center opacity-80">
                            <Gift size={24} className="text-gray-500 mb-2" />
                            <span className="text-[8pt] font-reqular text-gray-400 leading-tight">هدیه‌یِ فرزانه برای شما</span>
                        </div>
                        <div className="bg-white p-3 rounded-xl shadow-lg text-center rtl flex flex-col items-center justify-center opacity-80">
                            <CreditCard size={24} className="text-gray-500 mb-2" />
                            <span className="text-[8pt] font-reqular text-gray-400 leading-tight">کارت هدیه‌یِ فرزانه</span>
                        </div>
                    </div>
                </div>
            </>
        );
    }
    
    // ------------------------------------
    // حالت کاربر لاگین کرده (Logged In)
    // ------------------------------------
    const displayName = (user?.full_name || user?.first_name || "کاربر").trim();

    return (
        <>
            <div 
                className="p-6 pt-12 text-white rounded-b-3xl shadow-xl bg-cover bg-center bg-no-repeat"
                style={{ 
                    backgroundImage: `url(${loggedInBgUrl})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }}
            >
                <div className="flex justify-between items-start mb-4">
                     <button 
                        onClick={handleLogout}
                        className="p-2 -m-2 rounded-full hover:bg-white/20 transition duration-150"
                        title="خروج از حساب کاربری"
                     >
                         <LogOut size={30} className="text-white opacity-80" />
                     </button>
                     <div className="opacity-70"></div> 
                </div>
                
                <h1 className="text-2xl font-extrabold mb-1 text-right">
                    {displayName} عزیز
                </h1>
                <p className="text-[11px] opacity-90 mb-4 text-right">
                    به اپلیکیشن فرزانه خوش آمدید 
                </p>
            </div>

            {/* سه کادر حالت لاگین کرده - فعال */}
            <div className="p-4 -mt-10 relative z-5 mb-16">
                <div className="grid grid-cols-3 gap-3">
                    <WalletBalanceCard />
                    <Link 
                        to="/profile/discounts" 
                        className="bg-white p-3 rounded-xl shadow-lg text-center rtl flex flex-col items-center justify-center cursor-pointer hover:shadow-xl transition-shadow"
                    >
                        <Gift size={24} className="text-purple-700 mb-2" />
                        <span className="text-[8pt] font-regular text-gray-600 leading-tight">هدیه فرزانه برای شما</span>
                    </Link>
                    <Link 
                        to="/profile/gift-card" 
                        className="bg-white p-3 rounded-xl shadow-lg text-center rtl flex flex-col items-center justify-center cursor-pointer hover:shadow-xl transition-shadow"
                    >
                        <CreditCard size={24} className="text-purple-700 mb-2" />
                        <span className="text-[8pt] font-regular text-gray-600 leading-tight">کارت هدیه فرزانه</span>
                    </Link>
                </div>
            </div>
        </>
    );
}